import { Button, Col, DatePicker, Form, Input, Row } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";

const StyledFilterContainer = styled.div`
  &,
  & .filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    &__item {
      margin: 0.5rem;

      & .ant-form-item {
        margin: 0;
      }

      &--submit {
        align-self: flex-end;
      }
    }
  }
`;

export const AppDispatchInvoiceFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();

  useEffect(() => {
    const params = Object.fromEntries(new URLSearchParams(searchParams));
    form.setFieldsValue({
      date: params["date"] ? moment(params["date"]) : moment().add(1, "day"),
      dispatchId: params["dispatchId"] ?? undefined,
      vehicleNo: params["vehicleNo"] ?? undefined,
    });
  }, [form, searchParams]);

  const onSearch = (values: { date: moment.Moment | null; dispatchId?: string; vehicleNo?: string }) => {
    const params: Record<string, string> = {};
    if (values.date) {
      params["date"] = values.date.format("YYYY-MM-DD");
    }
    if (values.dispatchId?.trim()) {
      params["dispatchId"] = values.dispatchId.trim();
    }
    if (values.vehicleNo?.trim()) {
      params["vehicleNo"] = values.vehicleNo.trim();
    }
    setSearchParams(params);
  };

  const onReset = () => {
    form.setFieldsValue({
      date: moment().add(1, "day"),
      dispatchId: undefined,
      vehicleNo: undefined,
    });
    setSearchParams({});
  };

  return (
    <StyledFilterContainer>
      <Form
        form={form}
        name="dispatch-invoice-filter-form"
        onFinish={onSearch}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row className="filter">
          <Col xs={20} sm={6} md={4} lg={3} className="filter__item">
            <Form.Item name="date" label="Date">
              <DatePicker
                format="YYYY-MM-DD"
                disabledDate={(current) =>
                  current && current > moment().add(1, "day").endOf("day")
                }
                allowClear={false}
                placeholder="Select date"
                size="small"
              />
            </Form.Item>
          </Col>

          <Col xs={20} sm={5} md={4} lg={3} className="filter__item">
            <Form.Item name="dispatchId" label="Dispatch ID">
              <Input placeholder="Search by Dispatch ID" size="small" allowClear />
            </Form.Item>
          </Col>

          <Col xs={20} sm={5} md={4} lg={3} className="filter__item">
            <Form.Item name="vehicleNo" label="Vehicle No">
              <Input placeholder="Search by Vehicle No" size="small" allowClear />
            </Form.Item>
          </Col>

          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button type="primary" htmlType="submit" size="small">
                Search
              </Button>
            </Form.Item>
          </Col>

          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button size="small" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledFilterContainer>
  );
};
